import React, { useEffect, useRef, useState, useCallback } from "react";
import QuestionAnswer from "./QuestionAnswer";
import {
  createSurvey,
  getQuestions,
  updateAnswer,
  getLanguages,
  getFollowupQuestion,
  getSurveyStatments,
  getInitialQuestion,
  getAllFailedApiResponses,
  onSubmit
} from "../../services/apiServices";
import sendIcon from "../../assets/send-svgrepo-com (2).svg";
import "./QuestionsList.css";
import ProgressBar from "./ProgressBar";
import "normalize.css";
import ISO6391 from "iso-639-1";
import { emojiesValues } from "../../config/constants";
import OfflineMessage from "../Offline";
import Dropdown from "./Dropdown";
import {
  findNextValidQuestion as findNextValidQuestionUtil,
  sortQuestionListByConditionBlock,
} from "../../utils/questionsListLogic";

const LanguageSelection = [{ question: "Select Language" }];
/** Longer than staggered intro gap (1900ms) so timer fires once after the stream ends. */
const STAGGERED_SCROLL_DEBOUNCE_MS = 2000;
const IMMEDIATE_SCROLL_DEBOUNCE_MS = 320;
/** QuestionAnswer reveals choices after ~1000ms — follow-up scrolls catch that layout. */
const SETTLE_SCROLL_DELAYS_MS = [1050, 1700];
const SETTLE_SCROLL_DELAYS_AFTER_STAGGER_MS = [1150, 1850];

const changeFavicon = (iconURL) => {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = iconURL;
  document.getElementsByTagName("head")[0].appendChild(link);
};

export default function QuestionListV2() {
  const [intialQuestion, setIntialQuestion] = useState();
  const [delayedQuestions, setDelayedQuestions] = useState([]);
  const [showMessageList, setShowMessagesList] = useState([]);
  const [intialQuestions, setIntialQuestions] = useState([]);
  const [isSurveyStart, setIsSurveyStart] = useState(false);
  const [initialQIndex, setInitialQIndex] = useState(0);
  const [textValue, setTextValue] = useState("");
  const [messagesList, setMessagesList] = useState([]);
  const [index, setIndex] = useState(0);
  const textareaRef = useRef(null);
  const chatThreadRef = useRef(null);
  /** User scrolled up away from bottom — skip auto-scroll on edits / in-place DOM updates. */
  const userPausedAutoScrollRef = useRef(false);
  const lastShowMessageListLenRef = useRef(0);
  const lastDisplayedInitialLenRef = useRef(0);
  const lastDelayedQuestionsLenRef = useRef(0);
  const scrollDebounceTimerRef = useRef(null);
  const contentSettleTimersRef = useRef([]);
  const prevShouldWeStartRef = useRef(false);
  const prevSurveyStartedRef = useRef(false);
  const userScrollIntentRef = useRef(false);

  const clearContentSettleTimers = useCallback(() => {
    contentSettleTimersRef.current.forEach((id) => clearTimeout(id));
    contentSettleTimersRef.current = [];
  }, []);

  const scrollChatToBottom = useCallback((smooth = true, force = false) => {
    const root = chatThreadRef.current;
    if (!root || (!force && userPausedAutoScrollRef.current)) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!force && userPausedAutoScrollRef.current) return;
        root.scrollTo({
          top: root.scrollHeight,
          behavior: smooth ? "smooth" : "auto",
        });
      });
    });
  }, []);

  const scheduleContentSettledScroll = useCallback(
    (
      debounceMs = IMMEDIATE_SCROLL_DEBOUNCE_MS,
      smooth = true,
      { force = false, withSettlePasses = true } = {}
    ) => {
      if (force) {
        userPausedAutoScrollRef.current = false;
      }

      if (scrollDebounceTimerRef.current) {
        clearTimeout(scrollDebounceTimerRef.current);
      }
      scrollDebounceTimerRef.current = window.setTimeout(() => {
        scrollDebounceTimerRef.current = null;
        scrollChatToBottom(smooth, force);
      }, debounceMs);

      if (!withSettlePasses) return;

      clearContentSettleTimers();
      const settleDelays =
        debounceMs >= STAGGERED_SCROLL_DEBOUNCE_MS
          ? SETTLE_SCROLL_DELAYS_AFTER_STAGGER_MS.map(
              (ms) => debounceMs + ms
            )
          : SETTLE_SCROLL_DELAYS_MS;

      settleDelays.forEach((delayMs) => {
        const id = window.setTimeout(() => {
          // Follow-up passes must respect user scroll pause (never force).
          scrollChatToBottom(smooth, false);
        }, delayMs);
        contentSettleTimersRef.current.push(id);
      });
    },
    [clearContentSettleTimers, scrollChatToBottom]
  );
  const [editIsOn, setEditIsOn] = useState(false);
  const [shouldWeStart, setShouldWeStart] = useState(false);
  const [surveyDeclined, setSurveyDeclined] = useState(false);
  const [startSurvey, setStartSurvey] = useState({
    isSurveyStart: false,
    comment: "",
  });
  const [editedQuestionId, setEditedQuestionId] = useState(0);
  const [userInput, setUserInput] = useState(null);
  const [isResponseSubmitted, setIsResponseSubmitted] = useState(false);
  const [isLinkInValid, setIsInLinkValid] = useState(false);
  const [avlLangauges, setAvlLangauges] = useState([]);
  const [followupQuestions, setFollowupQuestions] = useState([]);
  const [selectedLangauge, setSelectedLanguage] = useState({});
  const [staticStatments, setStaticStatment] = useState({});
  const [selectOptionQuestion, setSelectOptionQuestion] = useState({
    question: "Please select the category to which your comment belongs:",
  });
  const [invalidLinkMessage, setInvalidLinkMessage] = useState(
    "Apologies for the inconvenience. The provided link is not valid. If you need any additional assistance or support, please reach out to your HR department."
  );
  /** Raw API value: `1` = Likert as text buttons; null/0/other = emoji (5- or 10-point). */
  const [surveyBouncetime, setSurveyBouncetime] = useState();
  const [textAreaRows, setTextAreaRows] = useState(2);
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);
  const [total, setTotal] = useState(0);
  const [isSurvyeSubmitted, setisSurvyeSubmitted] = useState(false);
  const [languagesCallbackCalled, setLanguagesCallbackCalled] = useState(false);
  const [displayedInitialQuestions, setDisplayedInitialQuestions] = useState([]);
  const [chroImage, setChroImage] = useState();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleTextareaInput = (event) => {
    const inputValue = event.target.value;
    // Count the occurrences of new lines (\n) in the input value
    const newLineCount = (inputValue.match(/\n/g) || []).length;
    // Set the minimum number of rows (e.g., 1) and the maximum number of rows (e.g., 5) based on your design.
    const minRows = 2;
    const maxRows = 5;
    setTextValue(event.target.value);
    // Calculate the number of rows based on the new line count, and keep it within the min and max rows
    const calculatedRows = Math.min(
      Math.max(minRows, newLineCount + 1),

      maxRows
    );
    setTextAreaRows(calculatedRows);
  };

  const getLanguagesCallBack = useCallback(async (surveyId, token) => {
    await createSurvey(token, surveyId)
      .catch((err) => {
        console.log(err);
        if (err?.response?.data) {
          if (err?.response?.data?.message === "Survey is expired") {
            setInvalidLinkMessage(
              statment?.[selectedLangauge.answer_code]?.surveyExpired
            );
            return;
          }
        }
        //   setIsInLinkValid(true);
      })
      .then(async (data) => {
        if (data) {
          let { questions,survey } = data;
          if (questions?.length > 0) {
            if (questions[0].submitdate) {
              const { statment } = await getSurveyStatments(
                surveyId,
                questions[0].startlanguage
              );
              setStaticStatment(statment);
              setSelectedLanguage({ answer_code: "en", answer: "English" });
              if(survey?.img_url){
                console.log('>>>>>>>> SURVEY>>>>>>>>>>>>>>> CHRO',survey.img_url)
                setChroImage(survey.img_url)
                changeFavicon(survey.img_url)
              }

              setIsResponseSubmitted(true);
              return;
            }
          }
        }
      });
    const { languages } = await getLanguages(surveyId);
    const { language, additional_languages, bouncetime, bounceaccounttype } =
      languages[0];
    console.log(additional_languages, "additional_languages");
    setSurveyBouncetime(bouncetime);
    const langaugesAvailbaleString = additional_languages;
    let langaugesAvailbale = [];
    if (langaugesAvailbaleString && langaugesAvailbaleString !== "") {
      langaugesAvailbale = langaugesAvailbaleString.split(" ");
    }
    langaugesAvailbale.unshift(language);
    langaugesAvailbale = langaugesAvailbale.map((lang) => {
      return {
        answer_code: lang,
        answer: ISO6391.getNativeName(lang),
      };
    });
    const uniqueLanguages = langaugesAvailbale.reduce((acc, current) => {
      const x = acc.find((item) => item.answer_code === current.answer_code);
      if (!x) {
        acc.push(current);
      }
      return acc;
    }, []);

    LanguageSelection[0].answers = uniqueLanguages;
    setAvlLangauges(uniqueLanguages);
    if (uniqueLanguages.length === 1) {
      setSelectedLanguage(langaugesAvailbale[0]);
    }
  }, []);

  const getQuestionList = useCallback(
    async (token, surveyId, langauge) => {
      await createSurvey(token, surveyId, langauge)
        .catch((err) => {
          console.log(err);
          if (err?.response?.data) {
            if (err?.response?.data?.message === "Survey is expired") {
              setInvalidLinkMessage(
                statment?.[selectedLangauge.answer_code]?.surveyExpired
              );
            }
          }
          setIsInLinkValid(true);
        })
        .then((data) => {
           if(data?.survey?.img_url){
                console.log('>>>>>>>> SURVEY>>>>>>>>>>>>>>> CHRO',data?.survey?.img_url)
                setChroImage(data?.survey.img_url)
                changeFavicon(data?.survey.img_url)
              }
        });
      const { languages } = await getLanguages(surveyId);
      const { bouncetime, bounceaccounttype } = languages[0];
      setSurveyBouncetime(bouncetime);

      const added_questions = [];
      const { followup_question } = await getFollowupQuestion(
        langauge,
        surveyId
      );
      setFollowupQuestions(followup_question);
      const { statment } = await getSurveyStatments(surveyId, langauge);
      setStaticStatment(statment);
      setInvalidLinkMessage(staticStatments.InvalidLink);
      setSelectOptionQuestion({
        question: statment?.[langauge].otypeOptionSelection,
      });
      const queryParams = new URLSearchParams(window.location.search);
      let name = queryParams.get("name") || "Name";
      const relation = queryParams.get("relation") || "Relation";
      let { initial_question } = await getInitialQuestion(
        langauge,
        surveyId,
        relation
      );
      // Update the initial_question array
      const mainLanguage = languages?.[0]?.language;
      const additional_lang = (languages?.[0]?.additional_languages || "")
        .split(" ")
        .map((lang) => lang.trim())
        .filter(Boolean);
      const languageList = [mainLanguage, ...additional_lang].filter(Boolean);
      const updated_initial_question = {};

      for (let lang of languageList) {
        const languageQuestions = Array.isArray(initial_question?.[lang])
          ? initial_question[lang]
          : [];

        updated_initial_question[lang] = languageQuestions.map((quest, index) => {
          const updatedQuestion = quest.question
            .replace(/\${name}/g, name)
            .replace(/\${relation}/g, relation);
          return {
            ...quest,
            qid: quest.qid != null ? quest.qid : index,
            question: updatedQuestion,
            answers: quest.answers ?? quest.answer,
          };
        });
      }

      setIntialQuestion(updated_initial_question);

      let { questions } = await getQuestions(
        token,
        surveyId,
        langauge,
        relation
      ).catch(() => {
        setIsInLinkValid(true);
      });
      questions = questions[langauge].map((quest) => {
        const updatedQuestion = quest.question
          .replace(/\${name}/g, name)
          .replace(/\${relation}/g, relation);
        return {
          ...quest,
          question: updatedQuestion,
        };
      });
      setTotal(questions.length);
      if (questions.length === 1) {
        setIsResponseSubmitted(true);
        return;
      }
      let followUpFlag = false;
     
      for (let question of questions) {
        if (question?.type === "L") {
          if (Number(bouncetime) === 1 && question.givenAnswer.answer_code) {
            const givenAnswer = question.answer.find((ans) => {
              return question.givenAnswer.answer_code === ans.answer_code;
            });
            question.givenAnswer.answer = givenAnswer.answer;
          }
          followUpFlag = true;
          added_questions.push(question);
        }
        if (question?.type === "O") {
          let newQuestionObj = { ...question };
          delete newQuestionObj.answer;

          // added_questions.push(question)
          if (Number(bounceaccounttype) === 1) {
            newQuestionObj.qid = newQuestionObj.qid + "comment";
            newQuestionObj.type = "comment";
            newQuestionObj.givenAnswer = {
              comment: newQuestionObj.givenAnswer.comment,
            };
            // added_questions.push(newQuestionObj);
            // question.question = statment?.otypeOptionSelection;
            question.givenAnswer.comment = null;
            added_questions.push(question);
            delete newQuestionObj.question;
            added_questions.push(newQuestionObj);
          } else {
            newQuestionObj.qid = newQuestionObj.qid + "comment";
            newQuestionObj.type = "comment";
            newQuestionObj.givenAnswer = {
              comment: newQuestionObj.givenAnswer.comment,
            };
            // added_questions.push(newQuestionObj);
            question.question = statment?.[langauge]?.otypeOptionSelection;
            question.givenAnswer.comment = null;
            added_questions.push(newQuestionObj);
            added_questions.push(question);
          }
        }
        if (question?.type === "T") {
          delete question.answer;
          // T questions with operator/value are follow-ups to L; add all and let findNextValidQuestion pick one
          const hasCondition = question?.operator != null && question?.value != null;
          if (hasCondition) {
            added_questions.push({
              ...question,
              comment: question?.givenAnswer?.comment,
            });
          } else if (
            question.title.startsWith(
              added_questions[added_questions.length - 1]?.title
            )
          ) {
            if (
              added_questions[added_questions.length - 1].givenAnswer
                ?.answer_code <= 3
            ) {
              added_questions.push({
                ...question,
                comment: question?.givenAnswer?.comment,
              });
            }
          } else {
            added_questions.push({
              ...question,
              comment: question?.givenAnswer?.comment,
            });
          }
        }
      }


      ///
      // let showQuestionList = added_questions.filter((quest) => {
      //   return (
      //     (quest?.givenAnswer &&
      //       quest?.givenAnswer?.answer_code &&
      //       quest?.givenAnswer?.answer_code !== null) ||
      //     (quest?.givenAnswer &&
      //       quest?.givenAnswer?.comment &&
      //       quest?.givenAnswer?.comment !== null)
      //   );
      // });
      let prevQuestion = null;
      const lastAnsweredIndex = added_questions.reduce(
        (lastIndex, quest, index) => {
          const answered =
            (quest?.givenAnswer &&
              quest?.givenAnswer?.answer_code &&
              quest?.givenAnswer?.answer_code !== null) ||
            (quest?.givenAnswer &&
              quest?.givenAnswer?.comment &&
              quest?.givenAnswer?.comment !== null);
          return answered ? index : lastIndex;
        },
        -1
      );

      // Filter questions after the last answered question
      let questionList = added_questions.slice(lastAnsweredIndex + 1);
      let showQuestionList = added_questions.slice(0, lastAnsweredIndex + 1);

      // Sort only the leading run of conditional follow-ups (same "block" after last L). Do not sort past the next L/non-conditional question (multiple follow-up blocks).
      questionList = sortQuestionListByConditionBlock(questionList);

      if (showQuestionList.length === 0) {
        setShowMessagesList([questionList.shift()]);
      } else {
        if (questionList.length === 0) {
          setShowMessagesList([
            ...showQuestionList,
            {
              qid: "SUBMIT01",
              question: statment?.[langauge]?.survey_submit_question,
              type: 'L',
              isSubmit: true,
              answer: JSON.parse(statment?.[langauge]?.survey_submit_answer),
              givenAnswer: {
                "answer_code": null,
                "comment": null
              },
              operator: null,
              value: null
            },
          ]);
         } else if(followUpFlag) {

        let answer_code =
        showQuestionList[showQuestionList.length - 1].givenAnswer
          ?.answer_code;
         

          // Use findNextValidQuestion instead of direct shift

          if(!answer_code){
            let nextQuestionFlag = true;
            if(questionList.length> 1){
 
              questionList = questionList.filter((quest) => {
             if (quest.operator === null && quest.value === null) {
               // Found a question with null operator - keep all remaining questions
               nextQuestionFlag = false; // Stop filtering after this point
               return true;
             }
             if (quest.operator !== null && quest.value !== null && nextQuestionFlag) {
               // Found a question with null operator - keep all remaining questions
               return false;
             }
             return true; // Keep questions after finding null operator
           });
            }
            setShowMessagesList([
              ...showQuestionList,
              questionList.shift(),
            ]);

          }else{
            let { nextQuestion, newQuestionList } = findNextValidQuestionUtil(
              questionList,
              answer_code
            );
            // Keep newQuestionList as-is so conditionals for the next L remain and show when that L is answered.
            questionList = [...newQuestionList];
            followUpFlag = false;
  
            if (nextQuestion) {
              setShowMessagesList([...showQuestionList, nextQuestion]);
              followUpFlag = false;
            } else {
              // If no valid question found, check if we should show submit question
              if (questionList.length === 0) {
                setShowMessagesList([
                  ...showQuestionList,
                  {
                    qid: "SUBMIT01",
                    question: statment?.[langauge]?.survey_submit_question,
                    type: 'L',
                    isSubmit: true,
                    answer: JSON.parse(statment?.[langauge]?.survey_submit_answer),
                    givenAnswer: {
                      "answer_code": null,
                      "comment": null
                    },
                    operator: null,
                    value: null
                  }
                ]);
              } else {
                setShowMessagesList([...showQuestionList]);
              }
            }
          }
          
        }
      }

      setMessagesList(questionList);
    },
    [setMessagesList, setShowMessagesList]
  );

  const onLanguageSelection = (lang) => {
    setSelectedLanguage(lang);
    LanguageSelection[0].givenAnswer = {
      answer: lang.answer_code,
      comment: lang.answer,
    };
  };
  let callback = false;
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    const surveyId = queryParams.get("surveyId");

    if (!selectedLangauge?.answer_code && !callback) {
      getLanguagesCallBack(surveyId, token);
      callback = true; // Add a state to track if the callback has been called
    }

    if (selectedLangauge?.answer_code) {
      getQuestionList(token, surveyId, selectedLangauge.answer_code);
    }
  }, [
    getQuestionList,
    selectedLangauge,
    isResponseSubmitted,
    getLanguagesCallBack,
    languagesCallbackCalled,
  ]);

  const onStartClick = async (answer, qid, gid) => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    const surveyId = queryParams.get("surveyId");
    const langCode = selectedLangauge?.answer_code;
    const introList = intialQuestion?.[langCode] || [];
    const startQuestion =
      introList.find(
        (q) =>
          Array.isArray(q?.answers) &&
          q.answers.some(
            (a) => a?.answer_code === "1" || a?.answer_code === "2"
          )
      ) || introList[introList.length - 1];
    const resolvedQid = qid ?? startQuestion?.qid;
    const resolvedGid = gid ?? startQuestion?.gid;

    const answerObject = {
      aid: answer?.aid,
      gid: resolvedGid,
      answerCode: answer?.answer_code,
      qid: resolvedQid,
      comment: null,
    };

    if (answer.answer_code === "1") {
      setSurveyDeclined(false);
      setShouldWeStart(true);
      setStartSurvey({
        isSurveyStart: true,
        comment: answer?.answer,
      });
      return;
    }

    if (answer.answer_code === "2") {
      setShouldWeStart(false);
      setSurveyDeclined(true);
      setStartSurvey({
        isSurveyStart: true,
        comment: answer?.answer,
      });

      const notNowText = staticStatments?.[langCode]?.NotNowResponse;
      const notNowEntry = notNowText
        ? { qid: "NOT_NOW_RESPONSE", question: notNowText }
        : null;

      setDisplayedInitialQuestions((prev) => {
        const base = prev.length > 0 ? prev : introList;
        if (!notNowEntry) return base;
        if (base.some((q) => q?.qid === "NOT_NOW_RESPONSE")) return base;
        return [...base, notNowEntry];
      });

      try {
        await updateAnswer(answerObject, token, surveyId, false);
      } catch (err) {
        console.error(err);
      }

      userScrollIntentRef.current = false;
      userPausedAutoScrollRef.current = false;
      scheduleContentSettledScroll(150, true, {
        force: true,
        withSettlePasses: true,
      });
    }
  };

  useEffect(() => {
    if (selectedLangauge?.answer_code) {
      if (surveyDeclined) {
        return undefined;
      }

      const hasSurveyFlowStarted =
        shouldWeStart || delayedQuestions.length > 0;

      // After flow starts, do not replay intro animation; only switch text language.
      if (hasSurveyFlowStarted) {
        const questions = intialQuestion?.[selectedLangauge.answer_code] || [];
        setDisplayedInitialQuestions(questions);
        return;
      }

      const questions = intialQuestion?.[selectedLangauge.answer_code] || [];
      setDisplayedInitialQuestions([]); // Reset displayed questions

      // Track timeouts for cleanup
      const timeouts = [];

      questions.forEach((question, index) => {
        const timeout = setTimeout(() => {
          setDisplayedInitialQuestions((prev) => [...prev, question]);
        }, index * 1900);

        timeouts.push(timeout);
      });

      if (questions.length > 0) {
        const finalScrollTimeout = setTimeout(() => {
          userScrollIntentRef.current = false;
          userPausedAutoScrollRef.current = false;
          scheduleContentSettledScroll(150, true, {
            force: true,
            withSettlePasses: true,
          });
        }, (questions.length - 1) * 1900 + 250);
        timeouts.push(finalScrollTimeout);
      }

      // Cleanup function to clear all timeouts
      return () => {
        timeouts.forEach((timeout) => clearTimeout(timeout));
      };
    }
  }, [
    initialQIndex,
    intialQuestion,
    selectedLangauge?.answer_code,
    delayedQuestions.length,
    shouldWeStart,
    surveyDeclined
  ]);

  useEffect(() => {
    if (editIsOn && editedQuestionId?.isComment) {
      textareaRef.current.focus();
    }
  }, [editIsOn, showMessageList, getQuestionList]);

  useEffect(() => {
    const root = chatThreadRef.current;
    if (!root) return undefined;

    const NEAR_BOTTOM_PX = 100;
    const markUserScrollIntent = () => {
      userScrollIntentRef.current = true;
    };
    const syncPauseFromScrollPosition = () => {
      if (!userScrollIntentRef.current) return;
      const gap = root.scrollHeight - root.scrollTop - root.clientHeight;
      userPausedAutoScrollRef.current = gap > NEAR_BOTTOM_PX;
    };

    root.addEventListener("wheel", markUserScrollIntent, { passive: true });
    root.addEventListener("touchmove", markUserScrollIntent, { passive: true });
    root.addEventListener("keydown", markUserScrollIntent);
    root.addEventListener("scroll", syncPauseFromScrollPosition, {
      passive: true,
    });

    return () => {
      root.removeEventListener("wheel", markUserScrollIntent);
      root.removeEventListener("touchmove", markUserScrollIntent);
      root.removeEventListener("keydown", markUserScrollIntent);
      root.removeEventListener("scroll", syncPauseFromScrollPosition);
    };
  }, []);

  useEffect(() => {
    const msgLen = showMessageList?.length ?? 0;
    const initLen = displayedInitialQuestions?.length ?? 0;
    const delayedLen = delayedQuestions?.length ?? 0;

    const prevInitLen = lastDisplayedInitialLenRef.current;
    const msgGrew = msgLen > lastShowMessageListLenRef.current;
    const initGrew = initLen > prevInitLen;
    const initBulkLoad = initGrew && initLen - prevInitLen > 1;
    const delayedGrew = delayedLen > lastDelayedQuestionsLenRef.current;

    const surveyJustActivated =
      shouldWeStart &&
      startSurvey.isSurveyStart &&
      (!prevShouldWeStartRef.current || !prevSurveyStartedRef.current);

    prevShouldWeStartRef.current = shouldWeStart;
    prevSurveyStartedRef.current = startSurvey.isSurveyStart;

    if (msgGrew || surveyJustActivated || initGrew || delayedGrew) {
      userPausedAutoScrollRef.current = false;
    }

    lastShowMessageListLenRef.current = msgLen;
    lastDisplayedInitialLenRef.current = initLen;
    lastDelayedQuestionsLenRef.current = delayedLen;

    if (userPausedAutoScrollRef.current && !surveyJustActivated) {
      return undefined;
    }

    if (editIsOn) {
      return undefined;
    }

    const isStaggeredStream = (initGrew && !initBulkLoad) || delayedGrew;
    const debounceMs = isStaggeredStream
      ? STAGGERED_SCROLL_DEBOUNCE_MS
      : IMMEDIATE_SCROLL_DEBOUNCE_MS;

    scheduleContentSettledScroll(debounceMs, true, {
      force: surveyJustActivated || msgGrew || initGrew || delayedGrew,
      withSettlePasses: true,
    });

    return () => {
      if (scrollDebounceTimerRef.current) {
        clearTimeout(scrollDebounceTimerRef.current);
        scrollDebounceTimerRef.current = null;
      }
    };
  }, [
    displayedInitialQuestions,
    delayedQuestions,
    showMessageList,
    shouldWeStart,
    startSurvey.isSurveyStart,
    editIsOn,
    scheduleContentSettledScroll,
  ]);

  useEffect(() => {
    return () => clearContentSettleTimers();
  }, [clearContentSettleTimers]);

  const onEditClick = (qid, isComment, gid) => {
    userScrollIntentRef.current = true;
    userPausedAutoScrollRef.current = true;
    if (scrollDebounceTimerRef.current) {
      clearTimeout(scrollDebounceTimerRef.current);
      scrollDebounceTimerRef.current = null;
    }
    clearContentSettleTimers();

    setEditIsOn(true);
    const question = showMessageList.find((quest) => quest.qid === qid);
    if (isComment) {
      setTextValue(question?.givenAnswer?.comment ?? "");
    } else {
      setTextValue("");
    }
    setEditedQuestionId({ qid: qid, isComment, gid });
  };

  const getMinCommentLength = (charValueLimit) => {
    const limit = Number(charValueLimit) || 0;
    return limit > 0 ? limit : 1;
  };

  const onSendClick = async () => {
    const trimmedComment = textValue?.trim() ?? "";
    if (!trimmedComment) {
      return;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    const surveyId = queryParams.get("surveyId");
    
    if (
      trimmedComment.length <
      getMinCommentLength(showMessageList[showMessageList.length - 1].charValueLimit)
    ) {
      const replacedString = staticStatments?.[
        selectedLangauge.answer_code
      ].mandatoryTextField.replace(
        /\${number}/g,
        getMinCommentLength(
          showMessageList[showMessageList.length - 1].charValueLimit
        )
      );
      alert(replacedString);
      return;
    }

    let isLast = false;

    if (editIsOn) {
      const quest = showMessageList.find((msg) => {
        return msg?.qid === editedQuestionId?.qid;
      });
      if (quest.type !== "comment" && quest.type !== "T") {
        const editedQuestionElement = document.getElementById(
          `question-${quest?.qid}`
        );

        // Scroll the element into view
        if (editedQuestionElement) {
          editedQuestionElement.scrollIntoView({ behavior: "smooth" });
        }
        alert(
          staticStatments?.[selectedLangauge.answer_code]?.alertOptionSelection
        );
      }
      const editMinLength = getMinCommentLength(
        quest?.charValueLimit ?? quest?.value
      );
      if (trimmedComment.length < editMinLength) {
        const replacedString = staticStatments?.[
          selectedLangauge.answer_code
        ]?.mandatoryTextField.replace(/\${number}/g, editMinLength);
        alert(replacedString);
        return;
      }
      const updatedList = showMessageList.map((msg) => {
        if (msg?.qid === editedQuestionId?.qid) {
          return {
            ...msg,
            givenAnswer: {
              ...msg.givenAnswer,
              comment: trimmedComment,
              skipped: false,
            },
          };
        }
        return msg;
      });
      setUserInput(trimmedComment);
      setTextValue("");
      setTextAreaRows(2);
      setEditIsOn(false);

      updateAnswer(
        { ...editedQuestionId, comment: trimmedComment },
        token,
        surveyId,
        isLast
      );
      let failedResponse = await getAllFailedApiResponses();
      if (failedResponse.length > 0) {
        setIsOnline(false);
      }
      setUserInput("");
      setShowMessagesList([...updatedList]);
    } else {
      if (
        showMessageList[showMessageList.length - 1].type === "O" ||
        showMessageList[showMessageList.length - 1].type === "L"
      ) {
        return alert(
          staticStatments?.[selectedLangauge.answer_code]?.alertOptionSelection
        );
      }
      showMessageList[showMessageList.length - 1].givenAnswer = {
        comment: trimmedComment,
      };
      if (
        showMessageList &&
        showMessageList[showMessageList.length - 1] &&
        showMessageList[showMessageList.length - 1].type &&
        showMessageList[showMessageList.length - 1].type
      ) {
        updateAnswer(
          {
            ...showMessageList[showMessageList.length - 1],
            comment: trimmedComment,
            isComment: true,
          },
          token,
          surveyId,
          isLast
        );
        let failedResponse = await getAllFailedApiResponses();
        if (failedResponse.length > 0) {
          setIsOnline(false);
        }
      }
      if (messagesList.length === 0 && !editIsOn) {
        isLast = true;
        setShowMessagesList([
          ...showMessageList,{
            qid: "SUBMIT01",
            question:
              staticStatments?.[selectedLangauge.answer_code]?.survey_submit_question,
            type: 'L',
            isSubmit:true,
            answer:JSON.parse(staticStatments?.[selectedLangauge.answer_code]?.survey_submit_answer),
            givenAnswer: {
              "answer_code": null,
              "comment": null
            },
            operator: null,
            value: null
          },
        ]);
        setTextValue("");
      }else{

      const currentQuestion = messagesList.shift();
      // currentQuestion.givenAnswer.comment = textValue;
      setShowMessagesList([...showMessageList, currentQuestion]);
      setUserInput(trimmedComment);
      setTextValue("");
      setTextAreaRows(2);
      }
      
    }
    
    
  };

  const isSurveyInputPhase =
    shouldWeStart &&
    startSurvey.isSurveyStart &&
    !isResponseSubmitted &&
    !isLinkInValid;

  const isThanksScreen = showMessageList?.[0]?.question?.includes(
    "Thank you for the response"
  );

  const currentSurveyQuestion = isSurveyInputPhase
    ? showMessageList?.[showMessageList.length - 1]
    : null;

  const contextSurveyQuestion =
    isSurveyInputPhase && editIsOn && editedQuestionId?.qid != null
      ? showMessageList?.find((q) => q?.qid === editedQuestionId?.qid) ??
        currentSurveyQuestion
      : currentSurveyQuestion;

  const isTextCommentQuestion =
    contextSurveyQuestion?.type === "T" ||
    contextSurveyQuestion?.type === "comment";

  const canUseTextInput =
    isSurveyInputPhase &&
    !!contextSurveyQuestion &&
    !isThanksScreen &&
    isTextCommentQuestion;

  const hasCommentText = (textValue?.trim()?.length ?? 0) > 0;

  const canUseSend = canUseTextInput && hasCommentText;

  const canSkipCurrentQuestion =
    isSurveyInputPhase &&
    !!contextSurveyQuestion &&
    !isThanksScreen &&
    !hasCommentText &&
    contextSurveyQuestion?.mandatory === false &&
    !contextSurveyQuestion?.isSubmit;

  const skipTooltipMessage = !isSurveyInputPhase || !contextSurveyQuestion
    ? "Available once the survey question starts."
    : contextSurveyQuestion?.isSubmit
    ? "Submit step cannot be skipped."
    : contextSurveyQuestion?.mandatory === true
    ? "This question is mandatory. Please answer to continue."
    : hasCommentText
    ? "Clear your comment to use Skip, or send your reply."
    : canSkipCurrentQuestion
    ? "Skip this optional question and move to the next one."
    : "Skip is unavailable for this question.";

  const onSkipClick = () => {
    if (!canSkipCurrentQuestion) {
      return;
    }

    const skipTargetQid =
      editIsOn && editedQuestionId?.qid != null
        ? editedQuestionId.qid
        : contextSurveyQuestion?.qid;

    const skippedGivenAnswer = {
      answer_code: null,
      comment: null,
      skipped: true,
    };

    const updatedShowList = showMessageList.map((msg) =>
      String(msg?.qid) === String(skipTargetQid)
        ? { ...msg, givenAnswer: skippedGivenAnswer }
        : msg
    );

    setTextValue("");
    setEditIsOn(false);
    setEditedQuestionId(0);

    const skipTargetIndex = updatedShowList.findIndex(
      (m) => String(m?.qid) === String(skipTargetQid)
    );
    const isReSkipOnEarlierQuestion =
      skipTargetIndex !== -1 &&
      skipTargetIndex < updatedShowList.length - 1;

    if (isReSkipOnEarlierQuestion) {
      setShowMessagesList(updatedShowList);
      return;
    }

    if (messagesList.length === 0) {
      setShowMessagesList([
        ...updatedShowList,
        {
          qid: "SUBMIT01",
          question:
            staticStatments?.[selectedLangauge.answer_code]?.survey_submit_question,
          type: "L",
          isSubmit: true,
          answer: JSON.parse(
            staticStatments?.[selectedLangauge.answer_code]?.survey_submit_answer
          ),
          givenAnswer: {
            answer_code: null,
            comment: null,
          },
          operator: null,
          value: null,
        },
      ]);
      return;
    }

    let remainingQuestionList = [...messagesList];
    let nextQuestion = null;

    if (contextSurveyQuestion?.type === "L") {
      let nextQuestionFlag = true;
      if (remainingQuestionList.length > 1) {
        remainingQuestionList = remainingQuestionList.filter((quest) => {
          if (quest.operator === null && quest.value === null) {
            nextQuestionFlag = false;
            return true;
          }
          if (
            quest.operator !== null &&
            quest.value !== null &&
            nextQuestionFlag
          ) {
            return false;
          }
          return true;
        });
      }
      nextQuestion = remainingQuestionList.shift();
    } else {
      nextQuestion = remainingQuestionList.shift();
    }

    setMessagesList(remainingQuestionList);
    if (nextQuestion) {
      setShowMessagesList([...updatedShowList, nextQuestion]);
      return;
    }

    setShowMessagesList(updatedShowList);
  };

  const findNextValidQuestion = (questionList, _showQuestionList, answer_code) => {
    return findNextValidQuestionUtil(questionList, answer_code);
  };

  async function onAnswerClick(answerObj, qid, gid, type, isEdit) {
    let isLast = false;
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");
    const surveyId = queryParams.get("surveyId");
    const { aid, answer, answer_code } = answerObj;
    if(qid === 'SUBMIT01' && Number (answer_code) === 1){
       onSubmit(token, surveyId).then(console.log)
       setisSurvyeSubmitted(true);
        setIntialQuestions([]);
        setDisplayedInitialQuestions([])
        setDelayedQuestions([]);
        showMessageList = setShowMessagesList([
          {
            question:
              staticStatments?.[selectedLangauge.answer_code]?.thanksResponse,
          },
        ]);
    }
    let answerObject = {
      aid,
      gid,
      answerCode: answer_code,
      qid,
      comment: isEdit ? textValue : userInput,
    };
    setTextValue("");
    let messages = showMessageList.map((msg) => {
      if (msg?.qid === qid) {
        if (type === "L") {
          return { ...msg, givenAnswer: { answer_code, answer: answer } };
        }
        if (msg?.givenAnswer?.comment && msg?.givenAnswer?.comment === null) {
          return {
            ...msg,
            givenAnswer: { answer_code: { answer_code, answer } },
          };
        }
        return {
          ...msg,
          givenAnswer: {
            answer_code: { answer_code, answer, comment: textValue },
          },
        };
      }
      return msg;
    });
    if (messagesList.length === 0 && !editIsOn ) {
      // setTimeout(()=>{
      //  window.location.href="https://we-matter.com/"
      //  },2000)
     setShowMessagesList([
        ...messages,{
          qid: "SUBMIT01",
          question:
            staticStatments?.[selectedLangauge.answer_code]?.survey_submit_question,
          type: 'L',
          isSubmit:true,
          answer:JSON.parse(staticStatments?.[selectedLangauge.answer_code]?.survey_submit_answer),
          givenAnswer: {
            "answer_code": null,
            "comment": null
          },
          operator: null,
          value: null
        },
      ]);
      updateAnswer(answerObject, token, surveyId, isLast).then(console.log); 
      return;
    
    }
    if (type && type === "L") {
      delete answerObj?.comment;
      delete answerObject.comment;
    }
    updateAnswer(answerObject, token, surveyId, isLast).then(console.log); //.catch(alert);
    let failedResponse = await getAllFailedApiResponses();
    if (failedResponse.length > 0) {
      setIsOnline(false);
    }
    if (type && type === "O") {
      setUserInput(null);
      setTextValue("");
    }
    if (
      !isEdit &&
      answerObject?.qid === showMessageList[showMessageList.length - 1]?.qid &&
      messages[messages.length - 1]?.givenAnswer?.answer_code !== null &&
      !isEdit &&
      !messagesList[messagesList.length - 1]?.type !== "O" &&
      !messagesList[messagesList.length - 1]?.type !== "T"
    ) {
      if (type === "L") {
        let { nextQuestion, newQuestionList } = findNextValidQuestion(
          [...messagesList],
          messages,
          answer_code
        );
        // Keep newQuestionList as-is so conditionals that apply to the next L (e.g. "My team is highly supportive" after "Do you have subordinates?") remain and show when that L is answered.
        setMessagesList(newQuestionList);
        if (nextQuestion) {
          setShowMessagesList([...messages, nextQuestion]);
        } else {
          // No more valid questions to show
          setShowMessagesList([...messages]);
        }
      } else {
        setShowMessagesList([...messages, messagesList.shift()]);
      }
      setEditIsOn(false);
    } else {
      setShowMessagesList([...messages]);
      setEditIsOn(false);
    }
  }

  useEffect(() => {
    const immediateFollowupStart =
      surveyBouncetime != null && Number(surveyBouncetime) === 1;
    if (!immediateFollowupStart) {
      const intervalId = setInterval(() => {
        if (index < followupQuestions.length && startSurvey.isSurveyStart) {
          const newQuestion = followupQuestions[index];
          setDelayedQuestions((prevQuestions) => [
            ...prevQuestions,
            newQuestion,
          ]);
          setIndex((prevIndex) => prevIndex + 1);
        } else {
          clearInterval(intervalId);
        }
        if (index === followupQuestions.length - 1) {
          setIsSurveyStart(true);
        }
      }, 1500);
      return () => {
        clearInterval(intervalId);
      };
    } else {
      setIsSurveyStart(true);
    }
  }, [index, followupQuestions, showMessageList, startSurvey, surveyBouncetime]);
  // Logging delayedQuestions to the console
  useEffect(() => {}, [delayedQuestions]);
  const disableZoom = () => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.content =
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
    }
  };

  const enableZoom = () => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.content =
        "width=device-width, initial-scale=1.0, maximum-scale=5.0";
    }
  };

  const handleFocus = () => {
    disableZoom();
  };

  const handleBlur = () => {
    enableZoom();
  };
  return isOnline ? (
    <>
      <ProgressBar completed={total - messagesList.length} total={total} />
      <Dropdown
        setSelectedLanguage={setSelectedLanguage}
        selectedLangauge={selectedLangauge}
        options={avlLangauges}
      ></Dropdown>
      <div className="card mobile:pl-2 mobile:pt-2 mobile:pr-2 mobile:pb-14 md:p-5 lg:p-7 bg-white">
        <div className="chat-thread" ref={chatThreadRef}>
          {isLinkInValid ? (
            <QuestionAnswer
              chroImage={chroImage}
              predfinedQuestionsForComment={{
                question:
                  staticStatments?.[selectedLangauge.answer_code]
                    ?.predfinedQuestionsForComment,
              }}
              questionObject={{ question: invalidLinkMessage }}
            />
          ) : null}
          {isResponseSubmitted ? (
            <>
              <QuestionAnswer
                chroImage={chroImage}
                predfinedQuestionsForComment={{
                  question:
                    staticStatments?.[selectedLangauge.answer_code]
                      ?.predfinedQuestionsForComment,
                }}
                questionObject={{
                  question:
                    staticStatments?.[selectedLangauge.answer_code]
                      ?.surveySubmitAlready,
                }}
              />
            </>
          ) : null}

          {!isSurvyeSubmitted &&
            !isResponseSubmitted &&
            !isLinkInValid &&
            !selectedLangauge?.answer_code &&
            avlLangauges?.length > 1 &&
            LanguageSelection.map((question, index) => (
              <QuestionAnswer
                chroImage={chroImage}
                predfinedQuestionsForComment={{
                  question:
                    staticStatments?.[selectedLangauge.answer_code]
                      ?.predfinedQuestionsForComment,
                }}
                showMessageList={showMessageList}
                questionObject={question}
                key={index}
                answerSelectionCallback={onLanguageSelection}
              />
            ))}
          {!isSurvyeSubmitted &&
            !isResponseSubmitted &&
            !isLinkInValid &&
            selectedLangauge?.answer_code &&
            avlLangauges?.length > 1 &&
            LanguageSelection.map((question, index) => (
              <QuestionAnswer
                chroImage={chroImage}
                predfinedQuestionsForComment={{
                  question:
                    staticStatments?.[selectedLangauge.answer_code]
                      ?.predfinedQuestionsForComment,
                }}
                showMessageList={showMessageList}
                questionObject={question}
                key={index}
                answerSelectionCallback={onLanguageSelection}
              />
            ))}
          {!isResponseSubmitted &&
            selectedLangauge?.answer_code &&
            !isLinkInValid &&
            displayedInitialQuestions.map((question, index) => (
              <QuestionAnswer
                chroImage={chroImage}
                predfinedQuestionsForComment={{
                  question:
                    staticStatments?.[selectedLangauge.answer_code]
                      ?.predfinedQuestionsForComment,
                }}
                showMessageList={showMessageList}
                startSurvey={startSurvey}
                questionObject={question}
                key={question.qid}
                answerSelectionCallback={
                  index === displayedInitialQuestions.length - 1 &&
                  !startSurvey.isSurveyStart
                    ? onStartClick
                    : onLanguageSelection
                }
              />
            ))}
          {!isResponseSubmitted &&
          shouldWeStart &&
          !isLinkInValid &&
          startSurvey.isSurveyStart
            ? delayedQuestions.map((question, index) => (
                <QuestionAnswer
                  chroImage={chroImage}
                  predfinedQuestionsForComment={{
                    question:
                      staticStatments?.[selectedLangauge.answer_code]
                        ?.predfinedQuestionsForComment,
                  }}
                  showMessageList={showMessageList}
                  startSurvey={startSurvey}
                  questionObject={question}
                  key={index}
                  answerSelectionCallback={
                    index === delayedQuestions.length - 1 &&
                    !startSurvey.isSurveyStart
                      ? onStartClick
                      : null
                  }
                />
              ))
            : null}
          {!isResponseSubmitted &&
          shouldWeStart &&
          !isLinkInValid &&
          startSurvey.isSurveyStart
            ? showMessageList?.map(function (question) {
                return (
                  <QuestionAnswer
                    chroImage={chroImage}
                    predfinedQuestionsForComment={{
                      question:
                        staticStatments?.[selectedLangauge.answer_code]
                          ?.predfinedQuestionsForComment,
                    }}
                    customLTypeQuestion={Number(surveyBouncetime) !== 1}
                    key={question?.qid}
                    setShowMessagesList={setShowMessagesList}
                    showMessageList={showMessageList}
                    onEditClick={onEditClick}
                    editedQuestionId={editedQuestionId}
                    setEditedQuestionId={setEditedQuestionId}
                    userInput={userInput}
                    editIsOn={editIsOn}
                    setEditIsOn={setEditIsOn}
                    setTextValue={setTextValue}
                    answerSelectionCallback={onAnswerClick}
                    questionObject={question}
                  ></QuestionAnswer>
                );
              })
            : null}
          <div id="chat-thread-end" />
        </div>
        <div className="textareacss">
          <textarea
            onFocus={canUseTextInput ? handleFocus : undefined}
            onBlur={canUseTextInput ? handleBlur : undefined}
            onChange={handleTextareaInput}
            ref={textareaRef}
            placeholder="Type your comment here...."
            disabled={!canUseTextInput}
            maxRows={5}
            type="text"
            value={textValue}
            name="commentresponse"
            id="bottom"
            className="commentbox text-base mobile:text-xs font-medium pl-5 pt-5 pr-28 mobile:pr-24 mobile:pl-3.5 mobile:pt-3.5"
            spellcheck="false"
            title={
              !canUseTextInput
                ? "Text reply is available on open comment questions."
                : ""
            }
          />
          <div className="actionButtonsContainer">
            <button
              type="button"
              onClick={onSkipClick}
              className="skipButton"
              disabled={!canSkipCurrentQuestion}
              title={skipTooltipMessage}
              aria-label="Skip current question"
            >
              Skip
            </button>
            <img
              alt="send button"
              onClick={canUseSend ? onSendClick : undefined}
              className={`sendIcon${
                canUseSend ? " sendIcon--enabled" : " sendIcon--disabled"
              }`}
              src={sendIcon}
              role="button"
              aria-disabled={!canUseSend}
              title={
                !canUseSend
                  ? "Type your comment and use send on open text questions."
                  : "Send comment"
              }
            />
          </div>
        </div>
      </div>
    </>
  ) : (
    <OfflineMessage></OfflineMessage>
  );
}
